const base = `remplacement`;
const chantierCreate = `${base}-create`;
const chantierShow = `${base}-show`;
const chantierShowDocument = `${base}-show_document`;
const chantierShowNettoyage = `${base}-show_nettoyage`;
const chantierShowChantier = `${base}-show_chantier`;
const chantierEdit = `${base}-edit`;
const chantierEditDocument = `${base}-edit_document`;
const chantierEditNettoyage = `${base}-edit_nettoyage`;
const chantierEditChantier = `${base}-edit_chantier`;

const basePath = '/' + base;

export default {
  basePath,
  base,
  create: chantierCreate,
  show: chantierShow,
  showDocument: chantierShowDocument,
  showNettoyage: chantierShowNettoyage,
  showChantier: chantierShowChantier,
  edit: chantierEdit,
  editDocument: chantierEditDocument,
  editNettoyage: chantierEditNettoyage,
  editChantier: chantierEditChantier,
};
